export function TimeIcon({
  className = "w-6 h-6",
}: {
  className?: string;
}) {
  return (
    <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_4065_8768)">
        <path d="M7.99967 4.00102V8.00102L10.6663 9.33435M14.6663 8.00102C14.6663 11.6829 11.6816 14.6677 7.99967 14.6677C4.31778 14.6677 1.33301 11.6829 1.33301 8.00102C1.33301 4.31912 4.31778 1.33435 7.99967 1.33435C11.6816 1.33435 14.6663 4.31912 14.6663 8.00102Z" stroke="#667085" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_4065_8768">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>

  );
}

export const displayName = "TimeIcon";
